import Avatar from "@cloudscape-design/chat-components/avatar";
import ChatBubble from "@cloudscape-design/chat-components/chat-bubble";
import { Alert, Badge, Box, Button, Checkbox, FormField, Header, KeyValuePairs, Modal, Popover, PromptInput, SpaceBetween, Spinner, SplitPanel } from '@cloudscape-design/components';
import { mdiFlagTriangle } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { downloadFile, getUser, setLoading } from "../../pages/commons/functions";
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import { ItemNote } from '../../resources/types';
import Copy from '../Copy';
import BadgeCustom from './BadgeCustom';


interface SidePanelMantProps {
    note: Partial<ItemNote>;
    edit?: boolean;
    onMessage?: (selected: any | undefined) => void;
}

const SidePanelMant: React.FC<SidePanelMantProps> = ({
    note,
    edit = false,
    onMessage
    //onDismiss,
    //onConfirm, 
}) => {

    const [showImageModal, setShowImageModal] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);
    const [imgUrl, setImgurl] = useState("");
    const [imageLoader, setImageLoader] = useState(false);
    const [noteAnswer, setNoteAnswer] = useState("");
    const [closeNote, setCloseNote] = useState(false);
    const [isOutOfFlight, setIsOutOfFlight] = useState(0);
    const [images, setImages] = useState<Array<{ url: string; name?: string; loaded: boolean }>>([]);
    const { data } = useGlobalState();



    const handleNewMessage = () => {
        onMessage({
            idMaintenance: note.idMaintenance,
            note: noteAnswer,
            closed: closeNote ? 1 : 0,
            isOutOfFlight: isOutOfFlight
        })
        setNoteAnswer("");
        setCloseNote(false);
    }
    useEffect(() => {
        if (note && note.images && note.images.length > 0) {
            let images = note.images.map(img => ({ ...img, loaded: false }));
            setImages(images);
        }
        setIsOutOfFlight(note.isOutOfFlight)

    }, [note]);
    return (
        <>
            <SplitPanel hidePreferencesButton header={`Detalle de nota`} closeBehavior='hide'
                headerActions={<Copy value={note?.idMaintenance?.toString() ?? ""} />}
            >
                <SpaceBetween direction='vertical' size='m'>
                    <KeyValuePairs columns={2} items={[
                        {
                            label: "Aeronave",
                            value: note.registration
                        },
                        {
                            label: "Usuario",
                            value: note.displayName
                        },

                    ]} />
                    <FormField label="Estado actual aeronave">
                        <Badge color={note?.equipment?.isOutOfFlight === 0 ? "green" : note?.equipment?.isOutOfFlight === 1 ? "red" : "grey"}>
                            {note?.equipment?.isOutOfFlight === 0 ? "En vuelo" : note?.equipment?.isOutOfFlight === 1 ? "Fuera de vuelo" : "Desconocido"}
                        </Badge>
                    </FormField>

                    <ChatBubble
                        key="INIT"
                        ariaLabel={`${note.displayName} at ${note.dateSubmited}`}
                        type="incoming"
                        avatar={
                            <Avatar
                                ariaLabel={note.displayName || ""}
                                tooltipText={note.displayName}
                                initials={note.initials}
                            />
                        }
                    >
                        <strong>{note.dateSubmited}:{" "}</strong>{note.note}
                    </ChatBubble>

                    {note && note.isOutOfFlight === 1 && (
                        <ChatBubble
                            ariaLabel="Generative AI assistant at 6:35:10pm"
                            type="incoming"
                            avatar={
                                <Avatar
                                    ariaLabel={note.displayName || ""}
                                    tooltipText={note.displayName}
                                    initials={note.initials}
                                />
                            }
                        >
                            <strong>{note.dateSubmited}:{" "}</strong>
                            <Box textAlign="center">
                                <BadgeCustom size={"small"} color="red">
                                    <Icon path={mdiFlagTriangle} size={0.75} />
                                    {"Equipo fue dejado fuera de vuelo"}</BadgeCustom>
                            </Box>
                        </ChatBubble>
                    )}


                    {note && note.images && note.images.length > 0 && (
                        <ChatBubble
                            ariaLabel="Generative AI assistant at 6:35:10pm"
                            type="incoming"
                            avatar={
                                <Avatar
                                    color="default"
                                    iconName="video-camera-on"
                                    ariaLabel="Generative AI assistant"
                                    tooltipText="Sistema"
                                />
                            }
                        >

                            {images.map((image, index) => (
                                <div
                                    key={index}
                                    style={{
                                        width: `${90 / (note.images?.length || 1)}%`,
                                        float: "left",
                                        margin: 5,
                                        borderRadius: 5,
                                        position: "relative",
                                    }}
                                >
                                    {!image.loaded && (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%",
                                            }}
                                        >
                                            <Spinner />
                                        </div>
                                    )}

                                    <img
                                        src={image.url}
                                        alt={`note-image-${index}`}
                                        onLoad={() => {
                                            // Update only this image’s "loaded" flag immutably
                                            setImages((prevImages) =>
                                                prevImages.map((img, i) =>
                                                    i === index ? { ...img, loaded: true } : img
                                                )
                                            );
                                        }}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: 5,
                                            visibility: image.loaded ? "visible" : "hidden",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            setImgIndex(index);
                                            setImgurl(image.url);
                                            setShowImageModal(true);
                                        }}
                                    />
                                </div>
                            ))}
                        </ChatBubble>
                    )}


                    {note && note.idUserRead?.length === 0 && (
                        <ChatBubble
                            ariaLabel="Generative AI assistant at 6:35:10pm"
                            type="outgoing"
                            avatar={
                                <Avatar
                                    color="default"
                                    iconName="status-info"
                                    ariaLabel="Generative AI assistant"
                                    tooltipText={"Sistema"}
                                />
                            }
                        >Nota no ha sido visualizada aun
                        </ChatBubble>
                    )}
                    {note && Array.isArray(note.idUserRead) && note.idUserRead.length > 0 && (
                        <ChatBubble
                            ariaLabel="Generative AI assistant at 6:35:10pm"
                            type="outgoing"
                            avatar={
                                <Avatar
                                    color="default"
                                    iconName="stop-circle"
                                    ariaLabel="Generative AI assistant"
                                    tooltipText={"Sistema"}
                                />
                            }
                        >Nota ha sido <Popover
                            header={"Visualización"}
                            content={
                                <SpaceBetween direction="vertical" size="xs">
                                    {note.idUserRead.map((u: number) =>
                                        <div key={`usr${u}`}>{getUser(u, data).displayName}</div>
                                    )}
                                </SpaceBetween>
                            } >visualizada</Popover>

                        </ChatBubble>
                    )}
                    {note && note.logs && note.logs.length > 0 && (

                        note.logs.map((log, index) => (
                            <ChatBubble
                                key={`log${index}`} // ensure a unique key
                                ariaLabel={`${log.displayName} at ${log.fechaMantLog}`}
                                type="outgoing"
                                avatar={
                                    <Avatar
                                        ariaLabel={log.displayName}
                                        tooltipText={getUser(log.idUserLog, data).displayName}
                                        initials={getUser(log.idUserLog, data).initials}
                                    />
                                }
                            ><strong>{log.fechaMantLog}:{" "}</strong>{log.log}
                            </ChatBubble>
                        ))


                    )}

                    {note && note.statusMant === 2 && (
                        <ChatBubble
                            ariaLabel="Generative AI assistant at 6:35:10pm"
                            type="outgoing"
                            avatar={
                                <Avatar
                                    color="default"
                                    iconName="notification"
                                    ariaLabel="Generative AI assistant"
                                    tooltipText={"Sistema"}
                                />
                            }
                        >
                            <strong>{note.dateClosed}:{" "}</strong>{"Nota ha sido finalizada"}
                        </ChatBubble>
                    )}

                    {note && note.statusMant === 1 && (
                        <>

                            <ChatBubble
                                ariaLabel="Generative AI assistant at 6:35:10pm"
                                type="outgoing"
                                avatar={
                                    <Avatar
                                        color="default"
                                        iconName="status-pending"
                                        ariaLabel="Generative AI assistant"
                                        tooltipText={"Sistema"}
                                    />
                                }
                            >
                                {"Nota pendiente de finalización"}
                            </ChatBubble>
                        </>
                    )}

                    {note && note.statusMant !== 2 && edit && (
                        <SpaceBetween direction='vertical' size='xs'>
                            {note && note.equipment && note.isOutOfFlight == 1 && (
                                <Alert header={"Fuera de vuelo"} type="warning">

                                    <Checkbox checked={isOutOfFlight === 1}
                                        onChange={(e) => {
                                            setIsOutOfFlight(e.detail.checked ? 1 : 0);
                                        }}
                                    > Equipo se encuentra fuera de vuelo. Desmarcar para poner en vuelo y notificar a las reservas provisionadas?
                                    </Checkbox>
                                </Alert>
                            )}
                            <PromptInput
                                onChange={({ detail }) => setNoteAnswer(detail.value)}
                                onAction={(action) => {
                                    handleNewMessage();
                                }}
                                value={noteAnswer}
                                actionButtonAriaLabel="Enviar"
                                actionButtonIconName="send"
                                ariaLabel="Prompt input with min and max rows"
                                maxRows={8}
                                minRows={3}
                                disableActionButton={noteAnswer.trim() === ""}
                                placeholder="Responder"
                            />
                            <Checkbox
                                onChange={({ detail }) =>
                                    setCloseNote(detail.checked)
                                }
                                checked={closeNote}
                            >
                                Finalizar nota al agregar respuesta
                            </Checkbox>
                        </SpaceBetween>
                    )}
                </SpaceBetween>
            </SplitPanel >
            <Modal header={
                <Header actions={<Button variant="link"

                    onClick={async () => {
                        setLoading(true);
                        downloadFile(note?.images?.[imgIndex]?.url || "", note?.images?.[imgIndex]?.name || "unknown.jpg")
                        setLoading(false);
                    }}


                >Descargar</Button>}>Detalle de imagen
                </Header>
            } visible={showImageModal} size="max" onDismiss={() => setShowImageModal(false)}>

                <img
                    src={note?.images?.[imgIndex]?.url || ""}
                    style={{
                        display: "block",         // remove inline spacing
                        maxWidth: "100%",         // never exceed modal width
                        maxHeight: "80vh",        // prevent overflow vertically
                        margin: "20px auto",      // center horizontally
                        height: "auto",           // keep aspect ratio
                        borderRadius: 5,
                        objectFit: "contain"      // ensures full image fits
                    }}
                    alt="Detalle"
                />
                {note?.images && note?.images.length > 1 && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <SpaceBetween direction="horizontal" size="l">
                            {note?.images?.map((image, index) => (
                                <Button
                                    key={index}
                                    variant={index === imgIndex ? "primary" : "normal"}
                                    onClick={() => setImgIndex(index)}
                                >
                                    {index + 1}
                                </Button>
                            ))}
                        </SpaceBetween>
                    </div>
                )}
            </Modal>
        </>
    );
};

export default SidePanelMant;